import Badge from '../ui/Badge';
import Button from '../ui/Button';

/**
 * Payment Method Card Component
 * Displays saved payment methods (credit cards, PayPal, etc.)
 */

const PaymentMethodCard = ({ paymentMethod, isDefault = false, onSetDefault, onDelete }) => {
  const getCardIcon = (brand) => {
    const icons = {
      visa: (
        <svg className="w-8 h-6" viewBox="0 0 32 20" fill="none">
          <rect width="32" height="20" rx="2" fill="#1434CB" />
          <text x="16" y="14" fill="white" fontSize="10" fontWeight="bold" textAnchor="middle">
            VISA
          </text>
        </svg>
      ),
      mastercard: (
        <svg className="w-8 h-6" viewBox="0 0 32 20" fill="none">
          <rect width="32" height="20" rx="2" fill="#EB001B" />
          <circle cx="12" cy="10" r="5" fill="#FF5F00" />
          <circle cx="20" cy="10" r="5" fill="#F79E1B" />
        </svg>
      ),
      amex: (
        <svg className="w-8 h-6" viewBox="0 0 32 20" fill="none">
          <rect width="32" height="20" rx="2" fill="#006FCF" />
          <text x="16" y="14" fill="white" fontSize="8" fontWeight="bold" textAnchor="middle">
            AMEX
          </text>
        </svg>
      ),
      discover: (
        <svg className="w-8 h-6" viewBox="0 0 32 20" fill="none">
          <rect width="32" height="20" rx="2" fill="#FF6000" />
        </svg>
      ),
    };
    return icons[brand?.toLowerCase()] || (
      <svg className="w-8 h-6" viewBox="0 0 32 20" fill="none">
        <rect width="32" height="20" rx="2" fill="#6B7280" />
      </svg>
    );
  };

  const getTypeIcon = (type) => {
    if (type === 'paypal') {
      return (
        <svg className="w-8 h-6" viewBox="0 0 32 20" fill="none">
          <rect width="32" height="20" rx="2" fill="#003087" />
          <text x="16" y="14" fill="white" fontSize="7" fontWeight="bold" textAnchor="middle">
            PayPal
          </text>
        </svg>
      );
    }
    return getCardIcon(paymentMethod.brand);
  };

  return (
    <div className="bg-white border border-neutral-200 rounded-lg p-4 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {/* Card Icon */}
          <div className="flex-shrink-0">{getTypeIcon(paymentMethod.type)}</div>

          {/* Card Details */}
          <div>
            <div className="flex items-center gap-2">
              <span className="font-semibold text-neutral-900">
                {paymentMethod.type === 'card' ? (
                  <>
                    {paymentMethod.brand} •••• {paymentMethod.last4}
                  </>
                ) : (
                  paymentMethod.email || 'PayPal Account'
                )}
              </span>
              {isDefault && <Badge variant="success">Default</Badge>}
            </div>
            {paymentMethod.type === 'card' && (
              <p className="text-sm text-neutral-600 mt-1">
                Expires {paymentMethod.expMonth}/{paymentMethod.expYear}
              </p>
            )}
            {paymentMethod.type === 'paypal' && (
              <p className="text-sm text-neutral-600 mt-1">{paymentMethod.email}</p>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          {!isDefault && onSetDefault && (
            <Button variant="ghost" size="sm" onClick={() => onSetDefault(paymentMethod.id)}>
              Set as Default
            </Button>
          )}
          {onDelete && (
            <button
              onClick={() => onDelete(paymentMethod.id)}
              className="text-neutral-400 hover:text-red-600 transition-colors"
              title="Delete payment method"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodCard;
